import React from "react";
import {node} from "prop-types";
import stylesCH from "../../gui/customHeader/CustomHeader.module.scss";
import classNames from "classnames";

export default function HeaderMenu({menu}) {
  return (
    <label htmlFor={"menu-burger"}
           className={classNames('header__wrapper', stylesCH.customHeader__wrapper)}>
      <div className={classNames('header__content', stylesCH.customHeader__content)}>
        {menu}
      </div>
    </label>
  )
}

HeaderMenu.propTypes = {
  menu: node
};
